// Scroll to and open target .collapsable element
$('.collapse').on('shown.bs.collapse', function () {
    var headerHeight = $("#navbar.sticky-header").height();
    if (!headerHeight) headerHeight = 0;
    var targetElement = $(this).closest('.collapsable');

    if (targetElement.length) {
        $('html, body').animate({
            scrollTop: targetElement.offset().top - headerHeight
        }, 500);

        $(targetElement).attr('tabindex', '-1').focus();
    }

    return false;
});

$('a[href^="#"]:not([href="#"]):not([data-toggle])').bind('click', function (e) {
    if (window.location.href.indexOf("zynteglo") > -1) {
        // Only ZYN sites
        var nav = $('#site-header');
        nav.addClass('hidden');    // hide the nav first, so that's taken into account when calculating the scroll to position (the nav will be hidden anyway when we scroll down)
    }
    var headerHeight = $("#navbar.sticky-header").height();
    if (!headerHeight) headerHeight = 0;
    var hash = $(this).attr("href");

    if ($(hash).hasClass("show")) {

        var targetElement = $(hash).closest('.collapsable');

        $('html, body').animate({
            scrollTop: $(targetElement).offset().top - headerHeight
        }, 500);

        $(hash).attr('tabindex', '-1').focus();

    } else if ($(hash).hasClass("collapse")) {

        $(hash).collapse('show');

        $(hash).attr('tabindex', '-1').focus();

    } else if ($(hash).attr('href') === 'join-movement') {

        var scrollButton = $("a.btn-tertiary[href='#join-movement']");
        $(scrollButton).fadeOut();

    } else {

        var header = document.getElementById("site-header");
        var pageNavigation = $('.page-navigation');
        var pageNavHeight = $('.page-navigation').outerHeight();
        if (pageNavigation.hasClass('page-navigation-left'))
        {
            pageNavHeight = 0;
        }
        var pageNavigationMob = $('.page-navigation-mobile');
        var menuTogglerHeight = $('#menu-toggler').outerHeight();
        var windowWidth = window.innerWidth;

        /*Check for 'position' property of #site-header element and if there is a .page-navigation element on the page.
         Also, check the screen width, since we are using a different HTML elements for pageNavigation on mobile and desktop*/

        if ($(header).css('position') != 'fixed' && pageNavigation.length > 0 && (pageNavHeight > 0 || pageNavigation.hasClass('page-navigation-left') ) && windowWidth > 991) {

            /*On desktop subtract pageNavHeight from scrollTop. */
            $('html, body').animate({
                scrollTop: $(hash).offset().top - pageNavHeight
            }, 500);

        } else if ($(header).css('position') != 'fixed' && pageNavigationMob.length > 0 && menuTogglerHeight > 0 && windowWidth <= 991) {
            /*On mobile subtract menuTogglerHeight from scrollTop. */
            $('html, body').animate({
                scrollTop: $(hash).offset().top - menuTogglerHeight
            }, 500);

        } else {

            $('html, body').animate({
                scrollTop: $(hash).offset().top - headerHeight
            }, 500);

        }

        $(hash).attr('tabindex', '-1').focus();
    }

    e.preventDefault();
});

//Hide scroll on click or when scrolled past

if ($(".scroll-hide").length > 0) {

    $(".scroll-hide").click(function () {
        $(this).hide();
    });

    var topofScroll = $(".scroll-hide").offset().top;
    var height = $(".scroll-hide").outerHeight();

    $(window).scroll(function () {
        if ($(window).scrollTop() > (topofScroll + height)) {
            $(".scroll-hide").hide();
        }
    });

}

//back to top smooth scroll
$(document).ready(function () {
    $(".back-to-top-button").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 600);
        return false;
    });
});
